'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'egg-fried';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f7fc';
var svgPathData = 'M474 173.3C510.8 223 500.4 293.1 450.7 330c-15.6 11.6-33.2 18.5-51.1 21c-21.2 3-44.4 12.1-64.7 24.6c-20.2 12.4-39.1 29.2-50.2 48.5C244.9 492.9 156.9 516.5 88 476.7S-4.5 348.9 35.3 280C61.7 234.3 76 168.6 80.4 118.2c2.3-26 13.6-51.4 34-70.9C159 4.4 229.9 5.8 272.7 50.4c16.5 17.2 40.1 34.5 64.7 48.9s51.3 26.4 74.4 32.3c24.1 6.2 46.2 20.3 62.1 41.8zM415.8 116c-42.4-10.9-101.2-45.1-131.5-76.7c-49-51-130-52.6-181-3.6C80.1 58 67.1 87 64.5 116.8C60.2 166.1 46.2 229.1 21.4 272C-22.7 348.5 3.5 446.4 80 490.6s174.4 18 218.6-58.6c18.8-32.5 66.1-60 103.3-65.2c20.5-2.9 40.6-10.8 58.4-24c56.8-42.1 68.7-122.3 26.6-179.1c-18.2-24.6-43.5-40.7-71-47.8zM224 144a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 208a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 240c0-26.5 21.5-48 48-48c4.4 0 8-3.6 8-8s-3.6-8-8-8c-35.3 0-64 28.7-64 64c0 4.4 3.6 8 8 8s8-3.6 8-8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faEggFried = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;